<template>
  <v-menu bottom left v-model="menu" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        @click:close="remove"
        :close="selectedfilter"
        class="ma-2"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        Proveedor
        <span v-if="selectedfilter">: {{ selectedfilter }}</span>
      </v-chip>
    </template>

    <v-card>
      <producto-filtro-proveedor
        type="list"
        @select-proveedor="setProveedor"
      ></producto-filtro-proveedor>
    </v-card>
  </v-menu>
</template>

<script>
import ProductoFiltroProveedor from "@/components/producto/filtros/producto.filtro.proveedor.vue";

export default {
  components: { ProductoFiltroProveedor },
  data() {
    return {
      selectedfilter: null,
      menu: false, // <-- control del menú
    };
  },

  watch: {
    "$route.query.proveedor": {
      handler(newProveedor) {
        this.selectedfilter = newProveedor;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setProveedor(value) {
      this.selectedfilter = value.nombre;
      this.updateQuery("proveedor", value.nombre);

      // Cerrar el menú al seleccionar
      this.menu = false;
    },

    updateQuery(key, value) {
      const query = { ...this.$route.query, [key]: value };
      this.$router.replace({ query });
    },

    remove() {
      this.selectedfilter = null;
      this.removeQuery("proveedor");
    },

    removeQuery(key) {
      const query = { ...this.$route.query };
      delete query[key];
      this.$router.replace({ query });
    },
  },
};
</script>
